/**
 * Where a character of a textarea sits on screen (the top left of its line), measured on a hidden
 * copy of the box with the same font, padding and width: a textarea does not say it itself.
 */
const COPIED = [
  "boxSizing",
  "width",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "borderStyle",
  "fontFamily",
  "fontSize",
  "fontWeight",
  "fontStyle",
  "fontVariationSettings",
  "letterSpacing",
  "lineHeight",
  "textTransform",
  "wordSpacing",
  "tabSize",
  "textIndent",
  "overflowWrap",
  "wordBreak",
] as const;

export function caretPoint(
  el: HTMLTextAreaElement,
  index: number,
): { x: number; y: number } {
  const copy = document.createElement("div");
  const style = getComputedStyle(el);
  for (const k of COPIED) copy.style[k] = style[k];
  Object.assign(copy.style, {
    position: "fixed",
    top: "0",
    left: "-9999px",
    visibility: "hidden",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    height: "auto",
  });
  copy.textContent = el.value.slice(0, index);
  const mark = document.createElement("span");
  mark.textContent = el.value.slice(index, index + 1) || ".";
  copy.appendChild(mark);
  document.body.appendChild(copy);
  const box = el.getBoundingClientRect();
  const point = {
    x: box.left + mark.offsetLeft - el.scrollLeft,
    y: box.top + mark.offsetTop - el.scrollTop,
  };
  copy.remove();
  return point;
}
